module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/main_sp_eae5b7300cb75c7cd6e87e8ca49b9a2c.jpg";